module.exports = __webpack_public_path__ + "static/media/main-featured-img.588d4caf.svg";